export const ROUTING_HISTORY_MODULE_NAME = 'routingHistory';
